import styled from "styled-components";
import * as Variable from "../../CSSVariables";

export const HeaderStyle = styled.section`
  background-color: ${Variable.white};
  height: 110px;
  z-index: 2;
  position: relative;
  border-bottom: 1px solid ${Variable.alto};

  .section-title {
    display: none;
    font-size: 0;
  }

  @media only screen and (min-width: ${Variable.tablet}) {
    height: 75px;
    box-shadow: 0 0 8px #00000038;
    border: 0;
  }
  h1 {
    font-size: 2.8rem;
    line-height: 38px;

    .shopping-help-link {
      font-size: 1.5rem;
      display: inline-block;
      position: absolute;
      right: -65%;
      bottom: 12px;
      font-weight: normal;

      @media only screen and (min-width: ${Variable.mobile}) {
        font-size: 1.6rem;
      }
      @media only screen and (min-width: ${Variable.tablet}) {
        display: none;
      }
    }
  }
  span {
    font-weight: ${Variable.regular};
  }
`;

export const UserNameStyle = styled.div`
  text-align: right;
  position: relative;
  position: absolute;
  top: 3rem;
  right: 1rem;

  @media only screen and (min-width: ${Variable.mobile}) {
    position: relative;
    top: unset;
    right: unset;
  }

  p {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    margin: 0;

    @media only screen and (min-width: ${Variable.mobile}) {
      right: 1.5rem;
    }

    a {
      font-size: 1.5rem;

      @media only screen and (min-width: ${Variable.mobile}) {
        font-size: 1.6rem;
      }
      &:hover {
        text-decoration: underline;
      }
    }
  }
`;

export const LinkStyle = styled.a`
  color: ${Variable.scienceBlue};

  &:hover {
    text-decoration: underline;
  }
`;

export const MobileContinueShopping = styled.div`
  margin-top: 12px;
  @media only screen and (min-width: ${Variable.tablet}) {
    display: none;
  }
`;
